import { graphql, useStaticQuery } from 'gatsby';
import { getHero, getHeroIntro, getBilateralList } from '../utils/utils';

function educationPage() {
  const data = useStaticQuery(graphql`
    query EducationQuery {
      allSanityPage(filter: { slug: { current: { eq: "education" } } }) {
        edges {
          node {
            _rawBody
          }
        }
      }
    }
  `).allSanityPage.edges[0].node._rawBody;

  const responseData = {
    heroIntro: getHeroIntro(data),
    bilateralContainer: getBilateralList(data),
  };
  return responseData;
}
export default educationPage;
